var React = require('react');

function CopyInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeWidth":".25","d":"M19.862 4v-.125H4.875v17.704H7.23V6.307h12.632V4zm5.263 4.364v-.125H9.086v19.886h16.039V8.364zm-2.355 17.33H11.44V10.67h11.33v15.024z"}));
}

CopyInline.defaultProps = {"width":"32","height":"32","fill":"none","viewBox":"0 0 32 32"};

module.exports = CopyInline;

CopyInline.default = CopyInline;
